export default "/images/logo-22.png?de90df0e6b0f767382a57dd05f22b83d";